
<span
  #viewVotePopover="ngbPopover"
  [ngbPopover]="viewVotePopoverContent"
  placement="left"
  [autoClose]="'outside'"
  triggers="manual"
></span>

<ng-template #viewVotePopoverContent>
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex flex-row w-full">
      <span [id]="id + '-title'" class="body-default-bold">{{
        popoverTitle
      }}</span>
    </div>
    <div class="flex flex-col w-full">
      <mat-divider class="mb-1 border-gray-300"></mat-divider>
      <div class="body-default-regular">

        <div class="flex flex-row" (click)="downloadAuthDocument()" role="button" aria-label="Download Document">
          <div class="text-orange-600 text-m material-symbols-rounded" >Download</div><div class="ml-2">Download</div>
        </div>

        <div class="flex flex-row mt-2"  (click)="previewAuthDocument()" role="button" aria-label="Preview Document">
          <div class="text-orange-600 text-m material-symbols-rounded">Preview</div><div class="ml-2">Preview</div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
